import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdContentCopy } from "react-icons/md";
import { getReferrals } from "../../services/auth/User";
import Loader2 from "../../components/Loader2";

function Rewards() {
  const [userData, setUserData] = useState(null);
    const [isPending, setIsPending] = useState(false);
    const [referrals, setReferrals] = useState({
      Level1: 0,
      Level2: 0,
      Level3: 0,
      Level4: 0,
      Level5: 0,
    });


     useEffect(() => {
      const storedUser = localStorage.getItem("userData");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUserData(parsedUser);
      }
      }, []);

      useEffect(() => {
        if (userData && userData.user && userData.user._id) {
          fetchReferrals();
        }
      }, [userData]);
  
  const fetchReferrals = async () => {
    setIsPending(true);
    try {
      const response = await getReferrals(userData.user._id);
      setReferrals(response.referralCountByLevel);
    
    } catch (error) {
      console.error("Failed to get referrals:", error);
      toast.error(error.message);
    } finally {
      setIsPending(false);
    }
  };


  const copyLink = () => {
    if (userData && userData.user && userData.user._id) {
      const referralLink = `http://www.cgthomes.com/register?r=${userData.user._id}`;
      navigator.clipboard
        .writeText(referralLink)
        .then(() => {
          toast.success("Link Copied!");
        })
        .catch((err) => {
          toast.error("Failed to copy the link.");
          console.error("Copy failed", err);
        });
    } else {
      toast.error("User ID not found.");
    }
  };




  return (
    <>
    {isPending ? <Loader2 /> : (
    <div className="contain">
        <h1>Profile</h1>

    <div className="boxy">      <div className="tab-top">
        <h3>Refer and Earn</h3>
      </div>
      <div className="seperator"></div>
      <div className="tab-body">
        <div className="copy-link">
          <h3>Copy your referral link</h3>
          <div className="link">
            <input
              type="text"
              value={
                userData && userData.user
                  ? `https://www.cgthomes.com/register?r=${userData.user._id}`
                  : ""
              }
              readOnly
            />
            <button className="btn-1" onClick={copyLink}>
              <span>Copy</span> <MdContentCopy />
            </button>
          </div>
        </div>
      </div>

      <div className="rewards-items">
        <h3>Achievements</h3>

        <div className="rewards-item">
          <h3>Reward 1 - 10$ worth CGT</h3>
          <p>Target - 100 Direct Referrals</p>
          <div className="progress-bar">
            <div className="progress-container">
              <progress id="progress-bar-2" value={referrals && referrals.Level1 ? referrals.Level1 : 0} max="100"></progress>
              <span className="progress-label">{referrals && referrals.Level1 ? referrals.Level1 : 0}/100</span>
            </div>
          </div>
        </div>

        <div className="rewards-item">
          <h3>Reward 2 - 20$ worth CGT</h3>
          <p>Target - 200 level 2 Referrals</p>
          <div className="progress-bar">
            <div className="progress-container">
              <progress id="progress-bar-2" value={referrals && referrals.Level2 ? referrals.Level2 : 0} max="200"></progress>
              <span className="progress-label">{referrals && referrals.Level2 ? referrals.Level2 : 0}/200</span>
            </div>
          </div>
        </div>

        <div className="rewards-item">
          <h3>Reward 3 - 30$ worth CGT</h3>
          <p>Target - 400 level 3 Referrals</p>
          <div className="progress-bar">
            <div className="progress-container">
              <progress id="progress-bar-2" value={referrals && referrals.Level3 ? referrals.Level3 : 0} max="400"></progress>
              <span className="progress-label">{referrals && referrals.Level3 ? referrals.Level3 : 0}/400</span>
            </div>
          </div>
        </div>

        <div className="rewards-item">
          <h3>Reward 4 - 40$ worth CGT</h3>
          <p>Target - 800 level 4 Referrals</p>
          <div className="progress-bar">
            <div className="progress-container">
              <progress id="progress-bar-2" value={referrals && referrals.Level4 ? referrals.Level4 : 0} max="800"></progress>
              <span className="progress-label">{referrals && referrals.Level4 ? referrals.Level4 : 0}/800</span>
            </div>
          </div>
        </div>

        <div className="rewards-item">
          <h3>Reward 5 - 50$ worth CGT</h3>
          <p>Target - 2000 level 5 Referrals</p>
          <div className="progress-bar">
            <div className="progress-container">
              <progress id="progress-bar-2" value={referrals && referrals.Level5 ? referrals.Level5 : 0} max="2000"></progress>
              <span className="progress-label">{referrals && referrals.Level5 ? referrals.Level5 : 0}/2000</span>
            </div>
          </div>
        </div>

      </div>
    </div>
     </div>
    )}
  </>
  );
}

export default Rewards;
